/** The docs index for an app locale. A locale without docs opens the English docs. */
export function helpIndexPath(locale: string, hasDocs: (locale: string) => boolean): string {
  return `/help/${hasDocs(locale) ? locale : 'en'}`;
}
